import React, { useEffect, useState } from 'react'
import leaderimg from '../../assests/images/leaderboard.svg'
import diamond from '../../assests/images/diamond.svg'
import back from '../../assests/images/back_pg.png'
import { Link } from 'react-router-dom'
const Header2 = (props) => {
   const [scrolled, setScrolled] = useState(false);
    useEffect(() => {
      const handleScroll = () => {
        setScrolled(window.pageYOffset > 0);
      };
  
      window.addEventListener('scroll', handleScroll);
  
      // Cleanup on unmount
      return () => {
        window.removeEventListener('scroll', handleScroll);
      };
    }, []);
  return (
  <div className="header navbar-fixed nav_detail">
  <nav className={scrolled ? 'scrolled top_nav' : 'top_nav'}>
    <div className="h_left">
      <Link to={'/'} className="btn_tp icon_sq">
        <img src={back} alt={back} />
      </Link>
    </div>
    <div className="h_right">
      <Link to={'/leaderboard'} className="btn_tp icon_sq">
        <img src={leaderimg} alt={leaderimg} />
      </Link>
      <Link to={'/Profile'} className="btn_tp">
        <img src={diamond} alt={diamond} />
        {props.diamond}
      </Link>
    </div>
  </nav>
</div>
  )
}

export default Header2
